import { Column } from "@ant-design/plots";
import React, { Fragment } from "react";
import { Card, Col } from "reactstrap";
import HeaderCard from "../Common/Component/HeaderCard";

const BasicColumnChart = ({
  title,
  raised_pending_amount,
  label_color = "#fff",
}) => {
  const data = [
    {
      type: "Pending",
      sales: parseFloat(raised_pending_amount?.po_pending)?.toFixed(2),
    },
    {
      type: "Raised",
      sales: parseFloat(raised_pending_amount?.total_po_raised)?.toFixed(2),
    },
  ];
  const config = {
    data,
    xField: "type",
    yField: "sales",
    label: {
      // 可手动配置 label 数据标签位置
      position: "middle",
      // 'top', 'bottom', 'middle',
      // 配置样式
      style: {
        fill: label_color,
        opacity: 1,
      },
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    meta: {
      type: {
        alias: "类别",
      },
      sales: {
        alias: "销售额",
      },
    },

    color: ({ type }) => {
      if (type === "Raised") {
        return "#5B8FF9";
      }

      return "#64DBAB";
    },
  };
  return (
    <Fragment>
      <Col>
        {/* <Card> */}
        <HeaderCard title={title} />
        <Column {...config} height={300} />
        {/* </Card> */}
      </Col>
    </Fragment>
  );
};

export default BasicColumnChart;
